var forEach = require('./forEach');

module.exports = function map(arr, fn) {
  var newArr = [];

  forEach(arr, function(key, item) {
    newArr.push(fn(key, item));
  });

  return newArr;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/chickencurry/lib/map.js
// module id = 1705
// module chunks = 0